import { render, staticRenderFns } from "./RobotList.vue?vue&type=template&id=208a2f6c&scoped=true"
import script from "./RobotList.vue?vue&type=script&lang=js"
export * from "./RobotList.vue?vue&type=script&lang=js"
import style0 from "./RobotList.vue?vue&type=style&index=0&id=208a2f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208a2f6c",
  null
  
)

export default component.exports